import React from 'react';
import { CoordinateLines } from '~/components/RectangularCoordinateLines';
import { CoordinateNumbers } from '~/components/RectangularCoordinateNumbers';
function RectangularCoordinate() {
    return (React.createElement(React.Fragment, null,
        React.createElement(CoordinateLines, null),
        React.createElement(CoordinateNumbers, null)));
}
export { RectangularCoordinate };
